/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  MobileDrawerComponent,
  DesktopDrawerComponent,
  MobileDrawerCabinetComponent
} from './SummaryDrawer';

const MobileDrawer = (props) => {
  const { isCabinets } = props;
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (isCabinets && mounted) {

    return (
      <>
        <MobileDrawerCabinetComponent />
      </>
    );
  }
  return (!isCabinets && mounted && (
    <MobileDrawerComponent>
      <DesktopDrawerComponent {...props} />
    </MobileDrawerComponent>
  ));

};

MobileDrawer.propTypes = {
  isCabinets: PropTypes.bool,
};

MobileDrawer.defaultProps = {
  isCabinets: false,
};

export default MobileDrawer;
